import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetMovesMissingRefCountsQueryVariables = Types.Exact<{
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetMovesMissingRefCountsQuery = { __typename?: 'query_root', allMoves: { __typename?: 'moves_aggregate', aggregate?: { __typename?: 'moves_aggregate_fields', count: number } | null }, upcomingMoves: { __typename?: 'moves_aggregate', aggregate?: { __typename?: 'moves_aggregate_fields', count: number } | null }, inProgressMoves: { __typename?: 'moves_aggregate', aggregate?: { __typename?: 'moves_aggregate_fields', count: number } | null }, completedMoves: { __typename?: 'moves_aggregate', aggregate?: { __typename?: 'moves_aggregate_fields', count: number } | null }, canceledMoves: { __typename?: 'moves_aggregate', aggregate?: { __typename?: 'moves_aggregate_fields', count: number } | null } };


export const GetMovesMissingRefCountsDocument = gql`
    query getMovesMissingRefCounts($start: timestamptz!, $end: timestamptz!, $customerId: bigint!) {
  allMoves: moves_aggregate(
    where: {active: {_eq: 1}, move_type: {_eq: "drive"}, consumer_pickup: {_eq: true}, reference_num: {_is_null: true}, _and: [{_or: [{customer_id: {_eq: $customerId}}, {payer_id: {_eq: $customerId}}]}, {_or: [{pickup_time: {_gte: $start, _lte: $end}}, {ready_by: {_gte: $start, _lte: $end}}]}]}
  ) {
    aggregate {
      count
    }
  }
  upcomingMoves: moves_aggregate(
    where: {active: {_eq: 1}, move_type: {_eq: "drive"}, consumer_pickup: {_eq: true}, reference_num: {_is_null: true}, cancel_status: {_is_null: true}, _and: [{_or: [{customer_id: {_eq: $customerId}}, {payer_id: {_eq: $customerId}}]}, {_or: [{status: {_is_null: true}}, {status: {_eq: "dispatched"}}]}, {_or: [{pickup_time: {_gte: $start, _lte: $end}}, {ready_by: {_gte: $start, _lte: $end}}]}]}
  ) {
    aggregate {
      count
    }
  }
  inProgressMoves: moves_aggregate(
    where: {active: {_eq: 1}, move_type: {_eq: "drive"}, consumer_pickup: {_eq: true}, reference_num: {_is_null: true}, cancel_status: {_is_null: true}, status: {_in: ["pickup started", "pickup arrived", "pickup successful", "delivery started", "delivery arrived"]}, _and: [{_or: [{customer_id: {_eq: $customerId}}, {payer_id: {_eq: $customerId}}]}, {_or: [{pickup_time: {_gte: $start, _lte: $end}}, {ready_by: {_gte: $start, _lte: $end}}]}]}
  ) {
    aggregate {
      count
    }
  }
  completedMoves: moves_aggregate(
    where: {active: {_eq: 1}, move_type: {_eq: "drive"}, consumer_pickup: {_eq: true}, reference_num: {_is_null: true}, cancel_status: {_is_null: true}, status: {_eq: "delivery successful"}, _and: [{_or: [{customer_id: {_eq: $customerId}}, {payer_id: {_eq: $customerId}}]}, {_or: [{pickup_time: {_gte: $start, _lte: $end}}, {ready_by: {_gte: $start, _lte: $end}}]}]}
  ) {
    aggregate {
      count
    }
  }
  canceledMoves: moves_aggregate(
    where: {active: {_eq: 1}, move_type: {_eq: "drive"}, consumer_pickup: {_eq: true}, reference_num: {_is_null: true}, cancel_status: {_is_null: false}, _and: [{_or: [{customer_id: {_eq: $customerId}}, {payer_id: {_eq: $customerId}}]}, {_or: [{pickup_time: {_gte: $start, _lte: $end}}, {ready_by: {_gte: $start, _lte: $end}}]}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetMovesMissingRefCountsQuery__
 *
 * To run a query within a React component, call `useGetMovesMissingRefCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovesMissingRefCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovesMissingRefCountsQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetMovesMissingRefCountsQuery(baseOptions: Apollo.QueryHookOptions<GetMovesMissingRefCountsQuery, GetMovesMissingRefCountsQueryVariables> & ({ variables: GetMovesMissingRefCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMovesMissingRefCountsQuery, GetMovesMissingRefCountsQueryVariables>(GetMovesMissingRefCountsDocument, options);
      }
export function useGetMovesMissingRefCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMovesMissingRefCountsQuery, GetMovesMissingRefCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMovesMissingRefCountsQuery, GetMovesMissingRefCountsQueryVariables>(GetMovesMissingRefCountsDocument, options);
        }
// @ts-ignore
export function useGetMovesMissingRefCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMovesMissingRefCountsQuery, GetMovesMissingRefCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMovesMissingRefCountsQuery, GetMovesMissingRefCountsQueryVariables>;
export function useGetMovesMissingRefCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMovesMissingRefCountsQuery, GetMovesMissingRefCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMovesMissingRefCountsQuery | undefined, GetMovesMissingRefCountsQueryVariables>;
export function useGetMovesMissingRefCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMovesMissingRefCountsQuery, GetMovesMissingRefCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMovesMissingRefCountsQuery, GetMovesMissingRefCountsQueryVariables>(GetMovesMissingRefCountsDocument, options);
        }
export type GetMovesMissingRefCountsQueryHookResult = ReturnType<typeof useGetMovesMissingRefCountsQuery>;
export type GetMovesMissingRefCountsLazyQueryHookResult = ReturnType<typeof useGetMovesMissingRefCountsLazyQuery>;
export type GetMovesMissingRefCountsSuspenseQueryHookResult = ReturnType<typeof useGetMovesMissingRefCountsSuspenseQuery>;
export type GetMovesMissingRefCountsQueryResult = Apollo.QueryResult<GetMovesMissingRefCountsQuery, GetMovesMissingRefCountsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (allMoves, upcomingMoves, inProgressMoves, completedMoves, canceledMoves): returns the full response object.
 * @source {@link src/features/missingRefReport/queries/getMovesMissingRefCounts.query.gql}
 */
export async function getMovesMissingRefCounts(
  variables: GetMovesMissingRefCountsQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetMovesMissingRefCountsQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetMovesMissingRefCountsQuery>(
    GetMovesMissingRefCountsDocument,
    variables,
    requestOptions
  )
}